<!-- <pre>{{ field.errors | json }}</pre> -->
<div
  *ngIf="field.invalid && !formErrors?.['samePassword'] && (field.dirty || field.touched)"
  class="error error-icon"
  [id]="fieldId + '-error'"
  role="alert"
  aria-live="polite">
  <div
    [attr.translate-key]="'COMMON.VALIDATORS.REQUIRED'"
    *ngIf="field.errors?.['required']"
    [innerHTML]="'COMMON.VALIDATORS.REQUIRED' | translate"></div>
  <div
    *ngIf="field.errors?.['minlength']"
    [attr.translate-key]="'COMMON.VALIDATORS.MIN_LENGTH'"
    [innerHTML]="'COMMON.VALIDATORS.MIN_LENGTH' | translate"></div>
  <div
    *ngIf="field.errors?.['maxlength']"
    [attr.translate-key]="'COMMON.VALIDATORS.MAX_LENGTH'"
    [innerHTML]="'COMMON.VALIDATORS.MAX_LENGTH' | translate"></div>
  <div
    *ngIf="field.errors?.['VALID_EMAIL']"
    [attr.translate-key]="'COMMON.VALIDATORS.VALID_EMAIL'"
    [innerHTML]="'COMMON.VALIDATORS.VALID_EMAIL' | translate"></div>
  <div
    *ngIf="field.errors?.['validatePhoneNumber']"
    [attr.translate-key]="'COMMON.VALIDATORS.VALID_TEL'"
    [innerHTML]="'COMMON.VALIDATORS.VALID_TEL' | translate"></div>
  <div
    *ngIf="field.errors?.['VALID_PASSPHRASE']"
    [attr.translate-key]="'COMMON.VALIDATORS.PASSPHRASE'"
    [innerHTML]="'COMMON.VALIDATORS.PASSPHRASE' | translate"></div>

  <div *ngIf="field.errors?.['PASSWORD_STRENGHT']" translate>
    <span class="ic1-flex-row ic1-flex" style="gap: 6px; align-items: center">
      <span
        [attr.translate-key]="'COMMON.VALIDATORS.PASSWORD_STRENGHT'"
        [innerHTML]="'COMMON.VALIDATORS.PASSWORD_STRENGHT' | translate"></span>
      <ng-ui-kit-tooltip [icId]="'ic1-tooltip-long'" [color]="'warning'">
        <h4
          [attr.translate-key]="'COMMON.VALIDATORS.PASSWORD_SECURITY'"
          [innerHTML]="'COMMON.VALIDATORS.PASSWORD_SECURITY' | translate"></h4>
        <div
          [attr.translate-key]="'COMMON.VALIDATORS.PASSWORD_DESCRIPTION'"
          [innerHTML]="
            'COMMON.VALIDATORS.PASSWORD_DESCRIPTION' | translate
          "></div>
      </ng-ui-kit-tooltip>
    </span>
  </div>
</div>
